import type { WidgetProps } from './registry';
import { decodeWidgetData } from './decode-widget-data';

type Worker = { workerId: string; channel?: string; status?: string; lastActiveAt?: string };

export function WorkersList(props: WidgetProps) {
  const workers = (decodeWidgetData(props.payload).workers ?? []) as Worker[];

  if (workers.length === 0) {
    return <p className="text-sm text-foreground-mute">No workers configured.</p>;
  }

  return (
    <table className="w-full text-sm">
      <thead>
        <tr className="border-b border-border text-[10px] uppercase tracking-wider text-foreground-mute">
          <th className="text-left py-1">Worker</th>
          <th className="text-left py-1">Channel</th>
          <th className="text-left py-1">Status</th>
          <th className="text-left py-1">Last Active</th>
        </tr>
      </thead>
      <tbody>
        {workers.map((w) => (
          <tr key={w.workerId} className="border-b border-border/30">
            <td className="py-1">{w.workerId}</td>
            <td className="py-1 text-foreground-mute">{w.channel ?? '—'}</td>
            <td className="py-1 text-foreground-mute">{w.status ?? '—'}</td>
            <td className="py-1 text-foreground-mute text-xs">{w.lastActiveAt ?? '—'}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
